<template>
  <div class="box">
    <header class="header">
      <i class="fa fa-globe" style="font-size: 16px"></i>
    </header>
    <div class="main">
      <!-- time on location -->
      <div class="flex">
        <i class="fa fa-globe" style="font-size: 16px"></i>
        <p class="flex-grow ml-2">Installed Capacity</p>
        <p>0.76</p>
      </div>
      <!-- geofence info -->
      <div class="flex">
        <i class="fa fa-globe" style="font-size: 16px"></i>
        <p class="flex-grow ml-2">MWH of Energy generated:</p>
        <p>
          49
        </p>
      </div>
      <div class="flex">
        <i class="fa fa-globe" style="font-size: 16px"></i>
        <p class="flex-grow ml-2">MWH of Energy consumed:</p>
        <p>0.76</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-geo-box",
  props: ["title", "value", "color", "voltage", "current", "icon"],
  data() {
    return {};
  },
  computed: {},
  components: {},
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #f9f9f9;
  border: 1px solid #f0f0f0;
  padding: 20px;
  height: 220px;
  display: flex;
  flex-direction: column;
  color: #999999;
}

.header {
  display: flex;
  justify-content: flex-end;
  color: #999999;
  font-size: 13px;

  .fa {
    border: 1px solid #cccccc;
    padding: 5px;
    border-radius: 5px;
    text-align: right;
  }
}

.icon {
  margin-right: 3px;
}

.flex {
  display: flex;
}

.main {
  width: 80%;
  margin-top: 20px;
}

.flex-grow {
  flex-grow: 1;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/components/customGeoBox.vue